import {useMutation, useQueryClient} from '@tanstack/react-query';
import {queryKey} from './material-variation-machine-preselect-query-keys';
import {
  MaterialVariationMachinePreselectForm,
  MaterialVariationMachinePreselectReply,
  MaterialVariationMachinePreselectUpdateMutation,
} from './material-variation-machine-preselect.model';
import {AxiosHttpClient} from '../../../envisia/auth/axios-http-client';
import {useAxiosError} from '../../errorhandling/useAxiosError';
import {environment} from '../../../../environments/environment';

export function useMaterialVariationMachinePreselectUpdateMutation(
  variationId: number,
): MaterialVariationMachinePreselectUpdateMutation {
  const queryClient = useQueryClient();
  const {mutate, isPending, error} = useMutation({
    mutationFn: (form: MaterialVariationMachinePreselectForm) =>
      AxiosHttpClient.postNullable<MaterialVariationMachinePreselectReply>(
        `${environment.apiv4uri}material/variation/${variationId}/preselect`,
        form),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: queryKey.detail(variationId),
      });
    },
  });

  const axiosError = useAxiosError<MaterialVariationMachinePreselectReply>(error);
  return {
    isPending,
    error: axiosError,
    mutate: (f, success) => mutate(f, {onSuccess: () => success()}),
  };
}
